module.exports = __webpack_public_path__ + "img/ico_down_selector.dc727e78.svg";